var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebflowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9531 0H18.0469C8.07986 0 0 8.07986 0 18.0469V58.9531C0 68.9201 8.07986 77 18.0469 77H58.9531C68.9201 77 77 68.9201 77 58.9531V18.0469C77 8.07986 68.9201 0 58.9531 0Z",
    fill: "#4353FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8636 31.1116C50.8636 31.1116 46.7083 44.13 46.4012 45.2354C46.2785 44.1505 43.249 20.7539 43.249 20.7539C36.1665 20.7539 32.4002 25.7893 30.3939 31.1116C30.3939 31.1116 25.3381 44.1709 24.9287 45.2558C24.9083 44.2323 24.1509 31.2343 24.1509 31.2343C23.7208 24.7044 17.7641 20.7539 12.9336 20.7539L18.7471 56.1865C26.1568 56.1661 30.1485 51.1512 32.2362 45.8087C32.2362 45.8087 36.6782 34.2842 36.8625 33.7726C36.9035 34.2638 40.0556 56.1865 40.0556 56.1865C47.4861 56.1865 51.4983 51.4992 53.6473 46.3612L64.0664 20.7539C56.7177 20.7539 52.8491 25.7688 50.8636 31.1116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflowicon);
export default __webpack_public_path__ + "static/media/webflowicon.23dfa4155109cf44acdf4e8ffc06ab97.svg";
export { ForwardRef as ReactComponent };